// src/components/Sidebar.jsx
import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import RolVentas from "./RolVentas";
import RolAdmin from "./RolAdmin";
import RolCompras from "./RolCompras";
import RolContabilidad from "./RolContabilidad";
import "bootstrap-icons/font/bootstrap-icons.css";

const Sidebar = ({ onToggleSidebar }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { userRole } = useAuth();
  const [preloaded, setPreloaded] = useState(false);

  useEffect(() => {
    function handleMove(e) {
      const li = e.target.closest(".sidebar-container .menu-item");
      if (!li) return;

      const { top, height, right } = li.getBoundingClientRect();

      // mitad vertical del item
      document.documentElement.style.setProperty(
        "--li-top",
        `${top + height / 2}px`
      );

      // borde derecho del item (borde interno del sidebar abierto)
      document.documentElement.style.setProperty("--li-right", `${right}px`);
    }

    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, []);

  /* ───────── 1. Pre-carga del logo ───────── */
  useEffect(() => {
    const img = new Image();
    img.src = "/img/logo-iciamex.png";
    img.onload = () => setPreloaded(true);
  }, []);

  /* ───────── 3. Toggle interno + notificación al Nav ───────── */
  const toggleSidebar = useCallback(() => {
    setIsOpen((prev) => {
      const next = !prev; // nuevo estado
      onToggleSidebar?.(next);

      /* 100 px cerrado  |  200 px abierto */
      const extra = next ? "250px" : "60px";
      document.documentElement.style.setProperty("--sidebar-extra", extra);

      return next;
    });
  }, [onToggleSidebar]);

  const closeSidebar = useCallback(() => {
    setIsOpen(false);
    onToggleSidebar?.(false);

    /* siempre vuelve a 100 px */
    document.documentElement.style.setProperty("--sidebar-extra", "60px");
  }, [onToggleSidebar]);

  /* ───────── 4. Render según rol ───────── */
  return (
    <>
      {userRole === "Ventas" && (
        <RolVentas
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          closeSidebar={closeSidebar}
          preloaded={preloaded}
        />
      )}

      {userRole === "Compras" && (
        <RolCompras
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          closeSidebar={closeSidebar}
          preloaded={preloaded}
        />
      )}

      {userRole === "Contabilidad" && (
        <RolContabilidad
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          closeSidebar={closeSidebar}
          preloaded={preloaded}
        />
      )}

      {userRole === "Administrador" && (
        <RolAdmin
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          closeSidebar={closeSidebar}
          preloaded={preloaded}
        />
      )}

      {isOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}
    </>
  );
};

export default Sidebar;
